import React, { useEffect, useState, useMemo } from 'react';
import SubscriptionsDesktop from './components/SubscriptionsDesktop';
import SubscriptionsMobile from './components/SubscriptionsMobile';

type Props = {
  variant?: 'auto' | 'desktop' | 'mobile';
  breakpoint?: number;
};

// Main entry point that can be used in routes or landing page
export default function SubscriptionsIndex({ variant = 'auto', breakpoint = 1024 }: Props = {}) {
  const [isDesktop, setIsDesktop] = useState(() => {
    if (variant === 'desktop') return true;
    if (variant === 'mobile') return false;
    if (typeof window === 'undefined') return true;
    return window.innerWidth >= breakpoint;
  });

  useEffect(() => {
    if (variant !== 'auto') return;
    const handler = () => setIsDesktop(window.innerWidth >= breakpoint);
    handler();
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [variant, breakpoint]);

  // Determine which component to render
  const renderComponent = useMemo(() => {
    if (variant === 'desktop') return <SubscriptionsDesktop />;
    if (variant === 'mobile') return <SubscriptionsMobile />;
    return isDesktop ? <SubscriptionsDesktop /> : <SubscriptionsMobile />;
  }, [variant, isDesktop]);

  return renderComponent;
}

// Export the component directly as well for backward compatibility
export { SubscriptionsDesktop, SubscriptionsMobile };
